/*
This view handles all scrolling related functionality for the portfolio
section. This knows when to lock and unlock scrolling and how to scroll
through the different galleries.
*/

(function($) {
	App._PortfolioView = Backbone.View.extend(_.extend({}, App._base, {

		// Put constants here


		// Put variables here

		$prevNav: null,
		$nextNav: null,
		$hash: null,
		$location: null,
		$content: null,
		$portfolioNav: null,

		portfolios: null,
		photos: null,

		currentPortfolio: 0,
		currentPhoto: 0,
		activeClass: 'active',
		peekClass: 'peek',
		peekDistance: 80,
		peekSpeed: 1,
		nextClicked: false,
		navHovered: false,
		moveForward: true,

		peek: {},
		repeekDebounce: 0,
		repeekDelay: 750,


		// Put functionality here

		OnPortfolioSelected: function(options) {
			this.currentPortfolio = options.index;
			this.photos = $('.photo-item', this.portfolios.eq(this.currentPortfolio));

			// Make sure the photos are stacked correctly and start over at the first photo
			this.currentPhoto = 0;
			this.SetPhotoOrder(this.photos.eq(0), this.photos.eq(1));
			
			this.ResetInactivePortfolios();

			this.SetPhotoPositions();
			this.SetLocationText();
			this.BuildHashMarks();
		},

			ResetInactivePortfolios: function() {
				this.portfolios.each(this.proxy(function(i) {
					if (i !== this.currentPortfolio) {
						this.SetPhotoPositions($('.photo-item', this.portfolios.eq(i)), 0);
					}
				}));
			},

		OnNextMouseOver: function(e) {
			this.navHovered = true;
			if (!this.moveForward) {
				this.ChangeDirection(true);
			}
			this.Peek();
		},
		OnNextMouseOut: function(e) {
			this.navHovered = false;
			if (!this.moveForward) {
				this.ChangeDirection(true);
			}
			this.UnPeek();
		},
		OnPrevMouseOver: function(e) {
			this.navHovered = true;
			if (this.moveForward) {
				this.ChangeDirection(false);
			}
			this.Peek();
		},
		OnPrevMouseOut: function(e) {
			this.navHovered = false;
			if (this.moveForward) {
				this.ChangeDirection(false);
			}
			this.UnPeek();
		},

			ChangeDirection: function(forward) {
				this.moveForward = forward;
				this.SetPhotoPositions();
			},

		OnNavClick: function(e) {
			e.preventDefault();
			if (this.nextClicked) { return; }
			this.NextPhoto();
		},

			Peek: function() {
				clearTimeout(this.repeekDebounce);
				
				if (this.nextClicked || this.isTablet() || Modernizr.touch) { return; }

				var $c = this.photos.eq(this.currentPhoto),
					$n = this.photos.eq(this.GetNextIndex(this.currentPhoto));

				// NOTE: We need the next photo to be in position already and indexed above the current
				// This is so that it shows the delayed animation.
				this.SetPhotoOrder($n, $c);

				this.AnimatePeek($c, $n, -(this.peekDistance), .1, 0, Power2.easeOut);
			},
			UnPeek: function() {
				if (this.nextClicked) { return; }
				clearTimeout(this.repeekDebounce);

				if (this.nextClicked) {
					this.nextClicked = false;
					this._UnPeekLocation();

					return;
				}

				var $c = this.photos.eq(this.currentPhoto),
					$n = this.photos.eq(this.GetNextIndex(this.currentPhoto));

				this.AnimatePeek($c, $n, 0, 0, 0, Power2.easeIn);
			}, 

				_UnPeekLocation: function() {
					if (this.moveForward) {
						var lX = this.GetTranslateX(this.$location);
						this.peek.lX = (!lX) ? 0 : lX;

						TweenMax.to(this.peek, this.peekSpeed, { lX: 0, ease: Power2.easeOut, onUpdate: this.proxy(function(e) {
							this.$location.css('transform', 'translateX('+(this.peek.lX)+'px)');
						})});
					}
				},

				AnimatePeek: function($c, $n, to, cDelay, nDelay, ease, cb) {
					// Just reverse the to distance if we're moving backwards.
					if (!this.moveForward) {
						to = -(to);
					}

					var ww = $(window).width(),
						cX = this.GetTranslateX($c),
						nX = this.GetTranslateX($n),
						lX = this.GetTranslateX(this.$location);

					this.peek = { cX: cX, nX: (this.moveForward) ? nX - ww : nX + ww, lX: lX };

					if (!this.peek.cX) { this.peek.cX = 0; }
					if (!this.peek.lX) { this.peek.lX = 0; }

					TweenMax.killTweensOf(this.peek);
					TweenMax.to(this.peek, this.peekSpeed, { cX: to, delay: cDelay, ease: ease, onUpdate: this.proxy(function(e) {
						$c.css('transform', 'translateX('+this.peek.cX+'px)');
					})});
					TweenMax.to(this.peek, this.peekSpeed, { nX: to, delay: nDelay, ease: ease,
						onUpdate: this.proxy(function(e) {
							var wwX = (this.moveForward) ? ww : -(ww);
							$n.css('transform', 'translateX('+(wwX + this.peek.nX)+'px)');

							if (!this.moveForward) {
								// Transform the content container and the portfolio nav in exact sync with the next slide.
								this.$content.css('transform', 'translateX('+(this.peek.nX)+'px)');
								this.$portfolioNav.css('transform', 'translateX('+(this.peek.nX)+'px)');
							}
						}),
						onComplete: this.proxy(function(e) {
							if (cb) { cb(); }
						})
					});

					if (this.moveForward) {
						TweenMax.to(this.peek, this.peekSpeed, { lX: to * .5, ease: ease, onUpdate: this.proxy(function(e) {
							this.$location.css('transform', 'translateX('+(this.peek.lX)+'px)');
						})});
					}
				},

				GetTranslateX: function($el) {
					return parseFloat($el.css('transform').split(',')[4]);
				},

			NextPhoto: function() {
				this.nextClicked = true;

				var ww = $(window).width(),
					$c = this.photos.eq(this.currentPhoto),
					$n = this.photos.eq(this.GetNextIndex(this.currentPhoto));

				// We're assuming the use is in peek mode. If we ever need to call this from
				// outside of peek mode, we need to pull the translateX from the element.
				this.peek = { cX: 0, nX: (this.moveForward) ? ww - this.peekDistance : -(ww) + this.peekDistance,
					pX: this.peekDistance
				};

				TweenMax.killTweensOf(this.peek);
				TweenMax.to(this.peek, this.peekSpeed, { nX: 0, pX: 0, ease: Expo.easeOut,
					onUpdate: this.proxy(function(e) {
						$n.css('transform', 'translateX('+(this.peek.nX)+'px)');

						if (!this.moveForward) {
							this.$content.css('transform', 'translateX('+(this.peek.pX)+'px)');
							this.$portfolioNav.css('transform', 'translateX('+(this.peek.pX)+'px)');
						}
					}),
					onComplete: this.proxy(function(e) {
						var ni = this.GetNextIndex(this.currentPhoto),
							nni = this.GetNextIndex(ni);

						this.currentPhoto = ni;
						this.SetPhotoOrder(this.photos.eq(ni), this.photos.eq(nni));

						this.SetPhotoPositions();
						this.SetLocationText();
						this.SetCurrentHashMark();

						clearTimeout(this.repeekDebounce);
						this.repeekDebounce = setTimeout(this.proxy(function() {
							this.nextClicked = false;

							// Check again to make sure the nav is still hovered before we peek again.
							if (this.navHovered) {
								this.Peek();
							}
						}), this.repeekDelay);
					})
				});
			},

				SetPhotoPositions: function(photos, index) {
					if (!photos) {
						photos = this.photos;
					}
					if (!index) {
						index = this.currentPhoto;
					}
					var $c = photos.eq(index),
						ww = $(window).width();

					if (!this.moveForward) {
						ww = -(ww);
					}

					photos.not($c).css('transform', 'translateX(' +ww+ 'px)');
					$c.css('transform', 'translateX(0px)');
				},
				SetPhotoOrder: function($i, $n) {
					this.photos.css('z-index', 0);
					$n.css('z-index', 1);
					$i.css('z-index', 2);
				},

				GetNextIndex: function(i) {
					var increment = (this.moveForward) ? 1 : -1,
						next = i + increment;

					// Regulate the index
					next = (next < 0) ?
						this.photos.length - 1 :
						next % this.photos.length;

					return next;
				},

				SetLocationText: function() {
					var $c = this.photos.eq(this.currentPhoto),
						l = $c.data('location'),
						$l = $('.entry-location', this.portfolios.eq(this.currentPortfolio))
					;

					if (this.$location.html() === l) {
						return;
					}

					var $obj = (this.isTablet()) ? $l : this.$location;
					TweenMax.to($obj, this.peekSpeed, { opacity: 0, ease: Power2.easeOut,
						onComplete: this.proxy(function() {
							$l.html(l);
							this.$location.html(l);
							TweenMax.to($obj, this.peekSpeed, { opacity: 1, ease: Power2.easeIn });
						})
					});
				},

				BuildHashMarks: function() {
					this.$hash.empty();
					this.photos.each(this.proxy(function(i) {
						var $h = $('<span />');
						if (i === 0) {
							$h.addClass(this.activeClass);
						}

						this.$hash.append($h);
					}));
				},

				SetCurrentHashMark: function() {
					var $s = $('span', this.$hash);
					$s.removeClass(this.activeClass);
					$s.eq(this.currentPhoto).addClass(this.activeClass);
				},

		OnWindowResize: function(e) {
			clearTimeout(this.resizeDebounce);
			this.resizeDebounce = setTimeout(this.proxy(function() {
				this.CheckSwipe();
			}), 250);
		},

			CheckSwipe: function() {
				console.log('check swipe');
				if (this.isTablet()) {
					this.BindSwipe();
				} else {
					this.UnbindSwipe(); 
				}
			},

			BindSwipe: function(e) {
				console.log('binding swipe');
				var swipeHandler = this.proxy(function(evt, dir) {
					console.log(evt, dir);
					if (dir == 'left') {
						this.ChangeDirection(true);
					} else if (dir == 'right') {
						this.ChangeDirection(false);
					} else {
						return false;
					}

					var $t = $(evt.target),
						$photo = $t.parents('.photo-item').first(),
						$portfolio = $t.parents('.portfolio-item').first(),
						$nav = $('.entry-navigation', $t.parents('.entry-container').first());

					this.currentPortfolio = $portfolio.index();
					this.photos = $('.photo-item', this.portfolios.eq(this.currentPortfolio));

					// Make sure the photos are stacked correctly and start over at the first photo
					this.currentPhoto = $photo.index();

					var $c = this.photos.eq(this.currentPhoto),
						ni = this.GetNextIndex(this.currentPhoto),
						$n = this.photos.eq(ni);

					// NOTE: We need the next photo to be in position already and indexed above the current
					// This is so that it shows the delayed animation.
					this.SetPhotoOrder($n, $c);

					this.NextPhoto();

					// Update the navigation
					$('> a', $nav)
						.removeClass('active')
						.eq(ni).addClass('active');
				});

				console.log($('.entry-photos', this.$el));

				$('.entry-photos', this.$el).swipe({
					swipeLeft: this.proxy(function(evt, dir, dist, dur, fing) {
						console.log('swipe left');
						evt.preventDefault();
						swipeHandler(evt, dir);
					}),
					swipeRight: this.proxy(function(evt, dir, dist, dur, fing) {
						console.log('swipe right');
						evt.preventDefault();
						swipeHandler(evt, dir);
					}),
					allowPageScroll: "vertical",
					preventDefaultEvents: false 
				});
			},

			UnbindSwipe: function(e) {
				console.log('swipe destroy');
				this.portfolios.swipe("destroy");
			},

		bindEvents: function() {
			this.$nextNav.mouseenter(this.proxy(this.OnNextMouseOver));
			this.$nextNav.mouseleave(this.proxy(this.OnNextMouseOut));
			this.$nextNav.click(this.proxy(this.OnNavClick));

			this.$prevNav.mouseenter(this.proxy(this.OnPrevMouseOver));
			this.$prevNav.mouseleave(this.proxy(this.OnPrevMouseOut));
			this.$prevNav.click(this.proxy(this.OnNavClick));

			$(window).resize(this.proxy(this.OnWindowResize));

			App.Events.on('portfolio-selected', this.proxy(this.OnPortfolioSelected));
		},

		ready: function() {
			this.bindEvents();
			this.CheckSwipe();
		},

		initialize: function(options) {
			this.$prevNav = $('.prev-navigation', this.$el);
			this.$nextNav = $('.next-navigation', this.$el);
			this.$hash = $('.hash-marks', this.$nextNav);
			this.$location = $('.navigation-title', this.$nextNav);

			this.$content = $('.content-container', this.$el);
			this.$portfolioNav = $('.portfolios-navigation', this.$el);

			this.portfolios = $('.portfolio-item', this.$el);

			// Initialize these backwards so that the first one gets it's hash marks
			for(var i = this.portfolios.length - 1; i >= 0; i--) {
				this.OnPortfolioSelected({index: i});
			}
			this.SetLocationText();

			App.Events.on('ready', this.proxy(this.ready));
		}
	}));
})(jQuery);  